import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faMinus,
  faXmark,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchCartItems } from "../../features/cartitemsSlice";
import { removeFromCart } from "../../features/cartSlice";
import { apiurl } from "../../Constants";
import axios from "axios";
import { toast } from "react-toastify";
import "./cart.css";
function Cart() {
  const user_id = localStorage.getItem("userId");

  const { items = [], total } = useSelector((state) => state.cartitems);

  const [cartItems, setCartItems] = useState(items);

  useEffect(() => {
    setCartItems(items.map((item) => ({ ...item })));
  }, [items]);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  useEffect(() => {
    if (user_id) {
      dispatch(fetchCartItems(user_id));
    }
  }, [dispatch, user_id]);

  const deleteCart = (product_id) => {
    dispatch(removeFromCart({ user_id, product_id }));
  };

  const hasOutOfStockItem = cartItems.some(
    (item) => item.product_quantity === 0
  );

  const overStockItems = cartItems.filter(
    (item) => item.product_quantity > 0 && item.quantity > item.product_quantity
  );

  const [loadingItem, setLoadingItem] = useState(null);

  const updateCart = async (product_id, updatedQty) => {
    localStorage.removeItem("couponDetails");
    try {
      setLoadingItem(product_id); // Start loading for the specific item
      await axios.post(apiurl + "cart_quantity_update", {
        user_id: user_id,
        product_id: product_id,
        quantity: updatedQty,
      });
      dispatch(fetchCartItems(user_id));
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingItem(null); // Stop loading after the API call is done
    }
  };

  const IncreaseQuantity = (product_id, currentQty, product_quantity) => {
    if (currentQty < product_quantity) {
      const updatedQty = currentQty + 1;
      updateCart(product_id, updatedQty);
    } else {
      toast.error(
        `Your Selected Order Quantity is Greater than Our Existing Stock`
      );
    }
  };

  const DecreaseQuantity = (product_id, currentQty) => {
    if (currentQty > 1) {
      const updatedQty = currentQty - 1;
      updateCart(product_id, updatedQty);
    } else {
      deleteCart(product_id);
    }
  };

  const [couponsList, setCouponsList] = useState({});

  useEffect(() => {
    const couponDetails = localStorage.getItem("couponDetails");
    if (couponDetails) {
      setCouponsList(JSON.parse(couponDetails));
    }
  }, []);

  return (
    <>
      {cartItems && cartItems.length > 0 ? (
        <section className="cart-sec-one pt-40 pb-40">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 left_col">
                {/* ===== DESKTOP / TABLET VIEW (unchanged) ===== */}
                <div className="inner-box table-responsive d-none d-lg-block">
                  <table className="table">
                    <thead>
                      <tr>
                        <th style={{ textAlign: "left" }}>Products</th>
                        <th>Price</th>
                        <th>Quantity</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cartItems.length > 0
                        ? cartItems.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td>
                                  <Link
to={`/product-details/${item.slug}`}
                                      style={{
                                        textDecoration: "none",
                                        color: "inherit",
                                      }}
                                    >
                                      <div className="inner-box">
                                        <div className="img-col">
                                          <img
                                          src={item.product_image[0]}
                                          style={{
                                            width: "90px",
                                            height: "90px",
                                          }}
                                          alt="img"
                                        />
                                      </div>
                                      <div className="content-col">
                                        {item.product_name}
                                      </div>
                                    </div>
                                  </Link>
                                </td>
                                <td>RM&nbsp;{item.price}</td>
                                <td>
                                  {item.product_quantity === 0 ? (
                                    <div className="out_of_stock">Out of Stock</div>
                                  ) : (
                                    <div className="quantity-box">
                                      <button
                                        className="btn_quantyity mx-1"
                                        onClick={() =>
                                          DecreaseQuantity(item.id, item.quantity)
                                        }
                                      >
                                        <FontAwesomeIcon icon={faMinus} />
                                      </button>
                                      <span
                                        style={{
                                          width: "20px",
                                          textAlign: "center",
                                        }}
                                      >
                                        {loadingItem === item.id ? (
                                          <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                          ></span>
                                        ) : (
                                          item.quantity
                                        )}
                                      </span>
                                      <button
                                        className="btn_quantyity mx-1"
                                        onClick={() =>
                                          IncreaseQuantity(
                                            item.id,
                                            item.quantity,
                                            item.product_quantity
                                          )
                                        }
                                      >
                                        <FontAwesomeIcon icon={faPlus} />
                                      </button>
                                    </div>
                                  )}
                                </td>
                                <td>RM&nbsp;{item.total_price}</td>
                                <td>
                                  <div
                                    className="remove_btn"
                                    onClick={() => deleteCart(item.id)}
                                  >
                                    <FontAwesomeIcon icon={faXmark} />
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                        : null}
                    </tbody>
                  </table>
                </div>

                {/* ===== MOBILE VIEW (new card design, no table) ===== */}
                <div className="d-lg-none">
                  {cartItems.map((item, index) => (
                    <div key={index} className="cart-mobile-card">
                      <div
                        className="cart-mobile-close"
                        onClick={() => deleteCart(item.id)}
                      >
                        <FontAwesomeIcon icon={faXmark} />
                      </div>

                      <div className="cart-mobile-header">
                        <Link to={`/product-details/${item.slug}`}>
                          <img
                            src={item.product_image[0]}
                            alt="img"
                            className="cart-mobile-img"
                          />
                        </Link>
                        <Link
                          to={`/product-details/${item.slug}`}
                          style={{ textDecoration: "none", color: "inherit" }}
                        >
                          <div className="cart-mobile-name">
                            {item.product_name}
                          </div>
                        </Link>
                      </div>

                      <div className="cart-mobile-row">
                        <span className="cart-mobile-label">Price</span>
                        <span className="cart-mobile-value">
                          RM&nbsp;{item.price}
                        </span>
                      </div>

                      <div className="cart-mobile-row">
                        <span className="cart-mobile-label">Quantity</span>
                        {item.product_quantity === 0 ? (
                          <div className="out_of_stock">Out of Stock</div>
                        ) : (
                          <div className="cart-mobile-qty-pill">
                            <button
                              onClick={() =>
                                DecreaseQuantity(item.id, item.quantity)
                              }
                            >
                              <FontAwesomeIcon icon={faMinus} />
                            </button>
                            <span>
                              {loadingItem === item.id ? (
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                              ) : (
                                item.quantity
                              )}
                            </span>
                            <button
                              onClick={() =>
                                IncreaseQuantity(
                                  item.id,
                                  item.quantity,
                                  item.product_quantity
                                )
                              }
                            >
                              <FontAwesomeIcon icon={faPlus} />
                            </button>
                          </div>
                        )}
                      </div>

                      <div className="cart-mobile-total-row">
                        <span className="cart-mobile-label">Total</span>
                        <span className="cart-mobile-value">
                          RM&nbsp;{item.total_price}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="inner-box-two mt-2">
                  <Link
                    to="/"
                    style={{ textDecoration: "none" }}
                    className="btn_4"
                  >
                    ADD MORE TO CART &nbsp;
                    <FontAwesomeIcon icon={faArrowRight} />
                  </Link>
                </div>
              </div>

              <div className="col-lg-4 right_col">
                <div className="main-box">
                  <div className="inner-box ">
                    <table className="table">
                      <tr>
                        <td className="order_summary_heading">Order summery</td>
                        <td>
                          Cart Value ( {items.length > 0 ? items.length : 0}{" "}
                          items )
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div className="inner-box-two">
                    <h6 className="mb-0">Total</h6>

                    <h6 className="mb-0">
                      {total ? `RM  ${total}` : `RM  0.00`}
                    </h6>
                  </div>

                  <div className="btn_box mt-3">
                    <button
                      className="btn_1"
                      onClick={() => {
                        if (hasOutOfStockItem) {
                          toast.error(
                            "Please remove out-of-stock items before continuing"
                          );
                          return;
                        }
                        if (overStockItems.length > 0) {
                          toast.error(
                            overStockItems
                              .map(
                                (item) =>
                                  `${item.product_name} - only ${item.product_quantity} available (you have ${item.quantity} in cart)`
                              )
                              .join("; ")
                          );
                          return;
                        }
                        navigate("/checkout-screen");
                      }}
                    >
                      Continue
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : (
        <p className="text-center mb-0 mt-5">No Products Found in Cart</p>
      )}
    </>
  );
}

export default Cart;

